/* Springwaves stone carousel: the stone nearest the middle is "active" (bigger); arrows step one stone at a time. */
(function () {
  'use strict';
  function init(wrap) {
    if (wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    var track = wrap.querySelector('[data-stonec-track]');
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-stonec-item]'));
    var prev = wrap.querySelector('[data-stonec-prev]');
    var next = wrap.querySelector('[data-stonec-next]');
    if (!track || !items.length) return;
    var active = -1, ticking = false, resizing = false, keep = 0, resizeTimer;

    function centreOf(i) {
      var it = items[i];
      return it.offsetLeft + it.offsetWidth / 2 - track.clientWidth / 2;
    }
    function nearest() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity;
      items.forEach(function (it, i) {
        var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }
    function setActive() {
      ticking = false;
      if (resizing) return;
      var i = nearest();
      if (i === active) return;
      if (active > -1) items[active].classList.remove('is-active');
      items[i].classList.add('is-active');
      active = i;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === items.length - 1;
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(items.length - 1, i));
      track.scrollTo({ left: centreOf(i), behavior: smooth ? 'smooth' : 'auto' });
    }
    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(setActive); }
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(active - 1, true); });
    if (next) next.addEventListener('click', function () { go(active + 1, true); });
    // stone sizes follow the screen width, so hold on to the middle stone while the screen resizes or rotates
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return; // phone address bar showing/hiding: height only
      lastW = window.innerWidth;
      if (!resizing) { resizing = true; keep = active; }
      go(keep, false);
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { go(keep, false); resizing = false; setActive(); }, 200);
    });
    go(parseInt(wrap.getAttribute('data-start'), 10) || 0, false);
    setActive();
  }
  function all() { document.querySelectorAll('[data-stonec]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', all);
})();
